export default __webpack_public_path__ + "3b40dfdaad30b2c16e36cfcfea1853c9.png";